import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';
import type { ReactElement, Ref, RefObject } from 'react';
import { useRef } from 'react';
import Heading from 'components/atoms/heading/Heading';
import Text from 'components/atoms/text/Text';
import styles from './ServicesCta.module.scss';
import type { ServicesCtaProps, ServicesCtaRef } from './ServicesCta.data';
import Accordion from 'components/blocks/accordion/Accordion';

export default function ServicesCta({
  ref,
  ...props
}: ServicesCtaProps & { ref?: Ref<ServicesCtaRef> }): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  return (
    <div
      ref={elementRef}
      className={classNames(styles.servicesCta, props.className, {
        [styles.hasNoCopy]: !props?.blok?.title && !props?.blok?.description,
      })}
      {...sbEditable(props.blok)}
    >
      <div className={classNames(styles.header, 'grid-gutter')}>
        {props?.blok?.title && (
          <Heading
            disableTriggerInOnScroll={false}
            as="h2"
            size="heading-03"
            className={classNames(styles.title)}
            transitionInType="splitCharsSlideInUp"
          >
            {props.blok.title.split('\n').map((line, index) => (
              <div key={`${line}-${index}`}>{line}</div>
            ))}
          </Heading>
        )}

        {props?.blok?.description && (
          <Text
            disableTriggerInOnScroll={false}
            as="p"
            size="body-large"
            className={classNames(styles.description)}
          >
            {props?.blok?.description}
          </Text>
        )}
      </div>

      {/* <span className={styles.line}></span> */}

      {props.blok.accordion?.[0] && (
        <Accordion blok={props.blok.accordion[0]} className={styles.accordion} numbered />
      )}
    </div>
  );
}
